<template>
    <div id="myWorks">
       <a-list :grid="{ gutter: 24, xxl: 4, xl: 4, lg: 4, md: 2, sm: 1, xs: 1 }" :dataSource="dataSource"
          :pagination="pagination" :loading="loadingStatus">
          <a-list-item slot="renderItem" slot-scope="item">
             <a-card :hoverable="true">
                <template class="ant-card-extra" slot="extra">
                   <span style="margin-bottom: 3px">{{ item.codeType_dictText }}</span>
                   <a-divider type="vertical" />
                   <span class="create-time">{{ item.createTime }}</span>
                </template>
                <a-card-meta>
                   <!-- <a-avatar class="card-avatar" slot="avatar" :src="item.avatar" size="small" /> -->
                   <div class="meta-cardInfo" slot="description">
                      <p>{{ item.workName }}</p>
                      <a @click="toDetail(item)" target="_blank">
                         <img v-if="item.workCover" :src="item.workCover_url" />
                         <img v-else :src="getCodeIcon(item.codeType)" />
                      </a>
                   </div>
                </a-card-meta>
                <template class="ant-card-actions" slot="actions">
                   <a-popconfirm title="确定删除吗?" @confirm="() => handleDelete(item.id)">
                      <a><a-icon type="delete" /></a>
                   </a-popconfirm>
                   <a :href="getEditorUrl(item.codeType) + '&workId=' + item.id" target="_blank">
                      <a-icon type="edit" />
                   </a>
                   <a-popover trigger="click" v-if="item.workType == 1 || item.workType == 2">
                      <template slot="content">
                         <qrcode :value="url.shareUrl + item.id" :size="250"></qrcode>
                      </template>
                      <a><a-icon type="share-alt" /></a>
                   </a-popover>
                </template>
             </a-card>
          </a-list-item>
       </a-list>
    </div>
 </template>
  
 <script>
 import { deleteAction, getAction, downFile } from '@/api/manage'
 import { getEditorUrl, getPlayerUrl, getCodeIcon } from '@/utils/codeTypeUtil.js'
 import QrCode from '@/components/tools/QrCode'
 export default {
    components: {
       qrcode: QrCode,
    },
    data() {
       return {
          queryParam: {
             orderBy: 'teaching_work.create_time',
             isAsc: false
          },
          pagination: {
             onChange: this.pageChange,
             pageSize: 9,
          },
          dataSource: [],
          url: {
             list: '/teaching/teachingWork/leaderboard',
             delete: '/teaching/teachingWork/delete',
             shareUrl: window._CONFIG['webURL'] + "/scratch3/scratch-mobile.html?workId=",
          },
          loadingStatus:false
       }
    },
    mounted() {
       this.pageChange(1, 9)
    },
    methods: {
       getEditorUrl,
       getPlayerUrl,
       getCodeIcon,
       pageChange(page, pageSize) {
        let _this = this
          this.dataSource = [];
          this.pagination.current = page;
          this.pagination.pageSize = pageSize;
          this.queryParam.pageNo = this.pagination.current;
          this.queryParam.pageSize = this.pagination.pageSize;
          getAction('/sys/sysDepart/mineClassroom').then(result=>{
            console.log(result , '班级')
            if(result.success){
                let depIdList = []
                result.result.forEach(v=>{
                    depIdList.push(v.id)
                })
                _this.queryParam.depId = depIdList.join(',')
                _this.getWorkList()
                
            }
          })
       },
       getWorkList: function () {
          var that = this;
          this.loadingStatus = true

          getAction(that.url.list, this.queryParam).then(res => {
             if (res.success) {
                that.dataSource = res.result.records
                that.pagination.total = res.result.total
             }
             if (res.code === 510) {
                that.$message.warning(res.message)
             }
             that.loadingStatus = false
          })
       },
       handleDelete: function (id) {
          var that = this;
          deleteAction(that.url.delete, { id: id }).then((res) => {
             if (res.success) {
                that.$message.success(res.message);
                that.getWorkList();
             } else {
                that.$message.warning(res.message);
             }
          });
       },
       toDetail(info) {
          if (info.codeType == 0) {
             this.$router.push("/mdView?workId=" + info.id);
          } else {
             this.$router.push( {path:'detail',query:{workId:info.id}});
          }
       },
    }
 };
 </script>
  
 <style lang="less" scoped>
 #myWorks{
    width: 100%;
    height: auto;
    background: #fff;
    padding: 15px;
 }
 /deep/.ant-card-extra {
    margin-left: 0 !important;
    height: 55px;
 }
 
 .meta-cardInfo {
    zoom: 1;
    margin-top: 16px;
    height: 230px;
 
    a {
       text-align: center;
       display: block;
    }
 
    img {
       width: 100%;
       height: auto;
    }
 
    >div {
       position: relative;
       text-align: left;
       float: left;
       width: 50%;
 
       p {
          line-height: 32px;
          font-size: 24px;
          margin: 0;
 
          &:first-child {
             color: rgba(0, 0, 0, 0.45);
             font-size: 12px;
             line-height: 20px;
             margin-bottom: 4px;
          }
       }
    }
 
    .create-time {
       margin: 0 20px;
    }
 }</style>